import React, { useEffect, useState } from "react";
import "./generalReports.css";
import FilterBox from "../../Components/filterBox/filterBox";
import Api from "../../services/api";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import InputReport from "../../Components/inputReport/inputReport";
import Button from '../../Components/commonButton/commonButton';
import Spinner from "react-bootstrap/Spinner";
import styles from "../General/details.module.css";
import "./generalReports.css";

const reportWorkShifts = () => {

  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [filters, setFilters] = useState([]);
  const [control,setControl] = useState([1]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      function firstLoad() {
          let array = [];
          Api.get("/work-shifts")
          .then((response) => {
            
          response.data.forEach((element) => {
            array.push({
              ["Turno"]: element.code,
              ["Início"]: element.start_time,
              ["Fim"]: element.end_time,
              ["Dias"] : element.days
            });
          });
          if (array.length > 0) {
              setData(array);
              setDataFilter(array);
              setLoading(false);
          };
         
        })
        .catch((err) => {
          alert(err);
        });  
      }
      
      firstLoad();

  },[])

  const saveText = (element) => {
      const {value, name} = element;
      setFilters({[`${name}`]:(value)});
  }

  const button = () => {
    setLoading(true);
    setControl([...[1]])
  } 

  useEffect(()=>{
    //Captura o nome dos filtros que estão sendo usados.
    let aux = Object.keys(filters);
    //Se existir uma filtragem ele usa a função .filter para filtrar o state data e armazenar em uma variável arr. 
    if(aux.length > 0 && filters[aux] != null && filters[aux] != ""){
        let arr = data.filter(element => (element[aux] == filters[aux]));
        
        //Depois ele armazena a varíavel arr no state dataFilter;
        setDataFilter([...arr]);
    }else{
      setDataFilter([...data]);
    }

    setLoading(false);
  },[control])

  return(
      <div className="filters boxReport">
          <FilterBox title="Filtros">
          <div className="elementFilter" type="input">
                  <InputReport name="Turno" title="Turno" parentCallback={saveText}  max="20" validationType="varchar" focus={true}/>
              </div>

              <div className="buttonFilter" type="button">
                  <Button size title="Gerar" icon="faGear" parentCallback={button}/>
              </div>
          </FilterBox>

          <div className="TableReport" id="tabela">
      {loading ? (
        
          <div style={{ marginTop: '20vh' }} className={styles.loader}>
            <Spinner variant="success" animation="border" />
            <strong>Carregando...</strong>
          </div>         
      ) : (
        <>
          {dataFilter.length > 0 ? (

              <TableList data={dataFilter}></TableList>
              
          ) : (

              <MessageTable message={"Sem dados para processar."} />

          )}
          </>
      )}
       </div>
    </div>
    );
};

export default reportWorkShifts;